(function () {
  'use strict';

  if (window.UnifiedAnalyticsProjector) {
    return;
  }

  const VERSION = '1.0.0';
  const ALLOWED_GA4_CLASSES = new Set([
    'ga4_dimension',
    'ga4_metric',
    'ga4_standard'
  ]);

  function getRegistry() {
    return (
      window.UnifiedProjectConfig &&
      window.UnifiedProjectConfig.ga4 &&
      window.UnifiedProjectConfig.ga4.parameterRegistry
    ) || {};
  }

  function project(eventName, payload, providerId) {
    const source = (
      payload &&
      typeof payload === 'object' &&
      !Array.isArray(payload)
    ) ? payload : {};

    if (providerId !== 'ga4') {
      return {
        success: true,
        event: eventName,
        provider: providerId,
        payload: Object.assign({}, source),
        dropped_fields: []
      };
    }

    if (
      !window.UnifiedSchema ||
      typeof window.UnifiedSchema.getAnalyticsMap !== 'function'
    ) {
      return {
        success: false,
        event: eventName,
        provider: providerId,
        payload: {},
        dropped_fields: Object.keys(source),
        error: 'schema_unavailable'
      };
    }

    const analyticsMap = window.UnifiedSchema.getAnalyticsMap(eventName);
    const registry = getRegistry();
    const projected = {};
    const dropped = [];

    Object.keys(source).forEach(function (fieldName) {
      const classification = analyticsMap[fieldName];
      const registryRule = registry[fieldName];
      const allowedBySchema = ALLOWED_GA4_CLASSES.has(classification);
      const allowedByRegistry = registryRule
        ? registryRule.send !== false
        : allowedBySchema;

      if (allowedBySchema && allowedByRegistry) {
        projected[fieldName] = source[fieldName];
        return;
      }

      dropped.push(fieldName);
    });

    return {
      success: true,
      event: eventName,
      provider: 'ga4',
      payload: projected,
      dropped_fields: dropped
    };
  }

  window.UnifiedAnalyticsProjector = {
    version: VERSION,
    project: project
  };
})();
